import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { TableReservationClientService } from 'src/app/services/apiclient/table-reservation/table-reservation.service';


@Component({
  selector: 'app-merchant',
  templateUrl: './merchant.component.html',
  styleUrls: ['./merchant.component.css']
})
export class MerchantComponent implements OnInit {
  currMerchant: any;
  loader: boolean = true;

  BookingPoinfofsales: any;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private clientMerchantApi: ClientMerchantsService,
    private trApiClient: TableReservationClientService,
  ) {

  }

  ngOnInit() {

    this.route.params.subscribe((params:any) => {
  

      if (params.merchantId) {

        this.clientMerchantApi.getMerchant(params.merchantId).subscribe(merchant => {

          this.currMerchant = merchant;

          if (this.currMerchant.options.includes(20)) {

            this.trApiClient.getBookingPointofSales(params.merchantId).then(trPointofsales => {
              this.BookingPoinfofsales = trPointofsales.booking_points_of_sale;
              this.loader = false;
            });

          }
        });
      }

    });
  }

  //goBooking
  selectPOS(point: any) {
    window.open(window.location.origin + "/tr/" + point.url_encode + "/" + point.id_webshop, "_blank");
  }

  goBack(): void {
    this.router.navigate(["/home/dashboard"]);
  }


}
